function lookupOrderType(type: string) {
  const lookup: any = {
    'market': 'Spot Market',
    'limit': 'Spot Limit',
    'spot-market': 'Spot Market',
    'spot_market': 'Spot Market',
    'spot-limit': 'Spot Limit',
    'spot_limit': 'Spot Limit',
    'margin-market': 'Margin Market',
    'margin_market': 'Margin Market',
    'margin-limit': 'Margin Limit',
    'margin_limit': 'Margin Limit',
    'spot-stop': 'Spot Stop Loss',
    'spot_stop': 'Spot Stop Loss'
  }
  if (type) {
    return lookup[type];
  }
  return lookup['market'];
}

function getTime(trade: any) {
  if (trade?.created_at) {
    return trade?.created_at
  } else {
    return trade?.time;
  }
}

function getPrice(trade: any) {
  if (trade?.executed_price) {
    return Number(trade.executed_price)
  } else if (trade?.price) {
    return Number(trade.price)
  } else {
    return 0
  }
}

function roundByExchange(number: any, symbol: string) {
  if (symbol.indexOf('-') !== -1) {
    return parseFloat(number).toFixed(4)
  }
  return parseFloat(number).toFixed(2)
}

export {
  lookupOrderType,
  getTime,
  roundByExchange,
  getPrice
}
